import React from 'react'
import { Box, Skeleton } from '@mui/material'

export const SearchResultsSkeleton = ({ dk, count = 6 }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    {Array.from({ length: count }).map((_, i) => (
      <Box
        key={i}
        sx={{
          p: 2,
          borderRadius: '10px',
          border: `1px solid ${dk.border}`,
          backgroundColor: dk.surface,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
          <Skeleton
            variant="rounded"
            width={80}
            height={22}
            sx={{ bgcolor: dk.chipBg, borderRadius: '6px' }}
          />
          <Skeleton
            variant="rounded"
            width={60}
            height={18}
            sx={{ bgcolor: dk.chipBg, borderRadius: '4px' }}
          />
        </Box>
        <Skeleton
          variant="text"
          width="70%"
          height={20}
          sx={{ bgcolor: dk.chipBg, mb: 0.5 }}
        />
        <Skeleton
          variant="text"
          width="45%"
          height={16}
          sx={{ bgcolor: dk.chipBg, mb: 1 }}
        />
        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
          <Skeleton
            variant="rounded"
            width={90}
            height={14}
            sx={{ bgcolor: dk.chipBg, borderRadius: '4px' }}
          />
          <Skeleton
            variant="rounded"
            width={70}
            height={14}
            sx={{ bgcolor: dk.chipBg, borderRadius: '4px' }}
          />
          <Skeleton
            variant="rounded"
            width={100}
            height={14}
            sx={{ bgcolor: dk.chipBg, borderRadius: '4px' }}
          />
        </Box>
      </Box>
    ))}
  </Box>
)

export const StatsHeroSkeleton = ({ dk }) => (
  <Box sx={{ textAlign: 'center', mb: 4, width: '100%', maxWidth: 600 }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
      <Skeleton
        variant="rounded"
        width={320}
        height={36}
        sx={{ bgcolor: dk.chipBg, borderRadius: '8px' }}
      />
    </Box>
    <Skeleton
      variant="text"
      width="60%"
      height={20}
      sx={{ bgcolor: dk.chipBg, mx: 'auto', mb: 3 }}
    />
    <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
      {[1, 2].map((i) => (
        <Skeleton
          key={i}
          variant="rounded"
          width={140}
          height={90}
          sx={{ bgcolor: dk.chipBg, borderRadius: '12px' }}
        />
      ))}
    </Box>
  </Box>
)

export default SearchResultsSkeleton
